<template>
  <div class="user-list">
    <div class="search-bar">
      <el-input v-model="searchParam.keyword_search" placeholder="输入证书名称" clearable @clear="getList"></el-input>
      <el-date-picker
        v-model="dates"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        @change="changeTime"
      >
      </el-date-picker>
      <el-button type="primary" @click="getList('clear')">查询</el-button>
      <el-button v-if="isteacher" type="primary" @click="toDetail">新增证书</el-button>
    </div>
    <div class="table">
      <el-table v-loading="loading" :data="tableData" border style="width: 100%">
        <el-table-column prop="title" label="证书名称" fixed="left" width="120px"> </el-table-column>
        <el-table-column prop="course" label="关联课程" width="120px">
          <template v-if="scope.row.course" slot-scope="scope">
            {{ scope.row.course.title }}
          </template></el-table-column
        >

        <el-table-column prop="type" label="证书类型">
          <template slot-scope="scope">
            {{ ["", "荣誉", "证书"][scope.row.type] }}
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间"> </el-table-column>

        <el-table-column label="操作" fixed="right" width="280">
          <template slot-scope="scope">
            <el-button v-if="isteacher" class="mid-blue" @click="toDetail(scope.row)">详情</el-button>
            <el-button class="mid-blue" @click="toDistribution(scope.row)">发放名单</el-button>
            <el-button v-if="isteacher" class="mid-red" @click="delItem(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          :current-page="page_index"
          :page-sizes="[10, 20, 60, 100]"
          :page-size="page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { certificateList, delCertificate } from "@/api/edu.js";
import Utils from "@/jslibs/utils";
import { mixin } from "@/mixins/pagination.js";
export default {
  mixins: [mixin],
  data() {
    return {
      loading: false,
      dates: [],
      teacherList: [],
      searchParam: {
        keyword_search: "",

        start_time: "",
        end_time: "",
      },
      tableData: [],
    };
  },
  computed: {
    isteacher() {
      const g = Utils.getCookie("X-Access-Group");
      return g != 927 && g != 952;
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    changeTime(val) {
      this.searchParam.start_time = val ? val[0] : "";
      this.searchParam.end_time = val ? val[1] : "";
      if (!val) {
        this.getList();
      }
    },
    delItem(row) {
      this.$confirm("确定要删除该证书吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delCertificate(row.uuid).then((res) => {
            if (res == true) {
              this.$message.success("成功");
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    toDistribution(row) {
      console.log(row);
      this.$router.push({
        path: "/distribution",
        query: row,
      });
    },
    toDetail(row) {
      console.log(row);
      this.$router.push({
        path: "/certificate-add",
        query: row,
      });
    },

    setTop(row) {},
    xiajia(row) {},
    agree() {},
    noagree(row) {
      this.$confirm("确定要拒绝该申请吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {})
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    async getList(type) {
      if (type == "clear") {
        this.page_index = 1;
      }
      const param = {
        page_index: this.page_index,
        page_size: this.page_size,
        ...this.searchParam,
      };
      this.loading = true;
      const res = await certificateList(param);
      this.loading = false;
      if (res.data instanceof Array) {
        this.tableData = res.data;
        this.total = res.total;
      }
    },
  },
};
</script>

<style scoped="scoped">
.user-list {
  background: white;
  padding: 10px;
  box-sizing: border-box;
}
</style>
